"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TMoignagesClients() {
  const testimonials = [{
    quote: "Service impeccable pour un drain bouché à Laval. L'inspection caméra a révélé le problème exact immédiatement. Très professionnel.",
    author: "Marc-André L.",
    location: "LAVAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_laval_drain.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_laval_drain.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_laval_drain.png-wvc-sizes"
  }, {
    quote: "OT Solution a sauvé mon sous-sol à Longueuil. Leur équipement de débouchage est à la fine pointe. Je recommande sans hésiter.",
    author: "Sophie G.",
    location: "LONGUEUIL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_longueuil_inspection.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_longueuil_inspection.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_longueuil_inspection.png-wvc-sizes"
  }, {
    quote: "Enfin des experts qui ne font que du drain. L'inspection caméra m'a évité des travaux inutiles. Précision chirurgicale.",
    author: "Jean-Philippe R.",
    location: "MONTRÉAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_montreal_expert.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_montreal_expert.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/client_montreal_expert.png-wvc-sizes"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [isPaused, testimonials.length]);
  const active = testimonials[activeIndex];
  return <section data-section-id="3611" id="témoignages-clients" className="dark bg-background py-16 px-4 sm:px-8 lg:px-16 text-foreground">
      <div ref={ref} className={`relative mx-auto max-w-7xl overflow-hidden rounded-md bg-card/40 px-6 py-20 sm:px-12 sm:py-24 md:px-20 md:py-28 lg:px-28 lg:py-32 transition-all duration-1000 ease-out border border-border/50 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
        {}
        <svg className="absolute inset-0 w-full h-full opacity-[0.05] pointer-events-none" viewBox="0 0 1200 600" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,300 C200,200 400,400 600,300 C800,200 1000,400 1200,300" stroke="var(--primary)" strokeWidth="1" fill="none" />
          <path d="M0,360 C200,260 400,460 600,360 C800,260 1000,460 1200,360" stroke="var(--primary)" strokeWidth="1" fill="none" />
          <path d="M0,240 C200,140 400,340 600,240 C800,140 1000,340 1200,240" stroke="var(--primary)" strokeWidth="1" fill="none" />
        </svg>

        {}
        <div className="relative flex items-center gap-4 mb-12 sm:mb-16">
          <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase font-medium" style={{
          letterSpacing: "0.2em"
        }}>
            [03] Témoignages Clients
          </span>
          <div className="flex-1 h-px bg-border/30" />
        </div>

        {}
        <div className="relative flex justify-center mb-6 sm:mb-8">
          <Quote className="size-20 sm:size-24 md:size-28 text-primary/20 -scale-x-100" strokeWidth={1} aria-hidden="true" />
        </div>

        {}
        <div className="relative min-h-[280px] sm:min-h-[260px] md:min-h-[240px] flex flex-col items-center text-center">
          {testimonials.map((t, i) => <div data-index={i} key={i} className={`absolute inset-0 flex flex-col items-center justify-start transition-all duration-1000 ease-out ${i === activeIndex ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
              <blockquote className="font-serif text-foreground max-w-3xl mx-auto leading-[1.2] tracking-tight" style={{
            fontSize: "clamp(1.5rem, 3.5vw, 2.25rem)"
          }}>
                "{t.quote}"
              </blockquote>

              <div className="flex flex-col items-center mt-10 sm:mt-12">
                <SafeHydrate><Avatar className="size-16 rounded-md overflow-hidden mb-4 ring-1 ring-primary/30">
                  <AvatarImage src={t.image} alt={t.author} className="grayscale hover:grayscale-0 transition-all duration-500" />
                  <AvatarFallback className="bg-muted text-primary font-mono text-lg">
                    {t.author.charAt(0)}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <p className="font-default font-semibold text-xl sm:text-2xl text-foreground mb-1">
                  {t.author}
                </p>
                <p className="font-mono text-xs text-muted-foreground uppercase" style={{
              letterSpacing: "0.15em"
            }}>
                  — {t.location} / EXPERTISE DRAIN
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="relative flex items-center justify-center gap-3 mt-16 sm:mt-20">
          {testimonials.map((_, i) => <Button data-index={i} key={i} variant="ghost" size="icon" onClick={() => setActiveIndex(i)} aria-label={`Voir témoignage ${i + 1}`} className={`p-0 h-auto w-auto hover:bg-transparent rounded-md transition-all duration-500 ${i === activeIndex ? "w-12 h-[2px] bg-primary" : "w-2 h-2 bg-border hover:bg-primary/50"}`} />)}
        </div>
      </div>
    </section>;
}